<template>
    <div>
        <training-card
            v-for="training, index in presentations"
            :key="index"
            :title="training.title"
            :link="training.link"
            :date="training.date"
            :poster="training.poster"
        />
    </div>
</template>

<script>
    import { TrainingCard } from '../trainingCard';

    export default {
        name: 'presentations',
        props: {
            presentations: {
                type: Array,
                default() {
                    return [];
                }
            }
        },
        components: {
            TrainingCard,
        },
    }
</script>


// WEBPACK FOOTER //
// Presentations.vue?61566644